/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccE2eFixtureResetDocument
 */
export interface PccE2eFixtureResetDocument {
    /**
     * 
     */
    relation_type: PccE2eFixtureResetDocumentRelationTypeEnum;
    /**
     * 
     */
    relation_id: string;
}


/**
 * @export
 */
export const PccE2eFixtureResetDocumentRelationTypeEnum = {
    ScreenerDocument: 'screener_document',
    ScreenerAdditionalDocument: 'screener_additional_document',
    ScreenerGeneratedDocument: 'screener_generated_document',
} as const;
export type PccE2eFixtureResetDocumentRelationTypeEnum = typeof PccE2eFixtureResetDocumentRelationTypeEnum[keyof typeof PccE2eFixtureResetDocumentRelationTypeEnum];


/**
 * Check if a given object implements the PccE2eFixtureResetDocument interface.
 */
export function instanceOfPccE2eFixtureResetDocument(value: object): value is PccE2eFixtureResetDocument {
    if (!('relation_type' in value) || value['relation_type'] === undefined) return false;
    if (!('relation_id' in value) || value['relation_id'] === undefined) return false;
    return true;
}

export function PccE2eFixtureResetDocumentFromJSON(json: any): PccE2eFixtureResetDocument {
    return PccE2eFixtureResetDocumentFromJSONTyped(json, false);
}

export function PccE2eFixtureResetDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccE2eFixtureResetDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'relation_type': json['relation_type'],
        'relation_id': json['relation_id'],
    };
}

export function PccE2eFixtureResetDocumentToJSON(json: any): PccE2eFixtureResetDocument {
    return PccE2eFixtureResetDocumentToJSONTyped(json, false);
}

export function PccE2eFixtureResetDocumentToJSONTyped(value?: PccE2eFixtureResetDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relation_type': value['relation_type'],
        'relation_id': value['relation_id'],
    };
}

